import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import axios from 'axios';
import VueCookies from 'vue-cookies';

Vue.config.productionTip = false

Vue.use(VueCookies);

new Vue({
  vuetify,
  axios,
  render: h => h(App)
}).$mount('#app')
